import { LicenseResponseProps } from '@/types/licensesProps'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface LicensesProps {
  licenses: LicenseResponseProps[]
}

const initialState: LicensesProps = {
  licenses: [],
}

const licensesSlice = createSlice({
  name: 'licenses',
  initialState,
  reducers: {
    handleSetLicenses(state, action: PayloadAction<LicensesProps>) {
      state.licenses = action.payload.licenses
    },
  },
})

export const { handleSetLicenses } = licensesSlice.actions

export default licensesSlice.reducer
